var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapdeviceImei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5H6V17H5.25V5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 5H21V17H18.75V5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5H4.5V17H3V5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5H18V13.25H17.25V5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5H10.5V13.25H9V5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5H16.5V13.25H15.75V5Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5H12V13.25H11.25V5Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5H8.25V13.25H6.75V5Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5H15V13.25H12.75V5Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 15.5C15.582 15.5 15.75 15.332 15.75 15.125C15.75 14.918 15.582 14.75 15.375 14.75H13.875C13.668 14.75 13.5 14.918 13.5 15.125V18.125C13.5 18.332 13.668 18.5 13.875 18.5H15.375C15.582 18.5 15.75 18.332 15.75 18.125C15.75 17.918 15.582 17.75 15.375 17.75H14.25V17H15.375C15.582 17 15.75 16.832 15.75 16.625C15.75 16.418 15.582 16.25 15.375 16.25H14.25V15.5H15.375Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 14.75C7.668 14.75 7.5 14.918 7.5 15.125V18.125C7.5 18.332 7.668 18.5 7.875 18.5C8.082 18.5 8.25 18.332 8.25 18.125V15.125C8.25 14.918 8.082 14.75 7.875 14.75Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 14.75C16.668 14.75 16.5 14.918 16.5 15.125V18.125C16.5 18.332 16.668 18.5 16.875 18.5C17.082 18.5 17.25 18.332 17.25 18.125V15.125C17.25 14.918 17.082 14.75 16.875 14.75Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5182 14.778C12.3788 14.721 12.2175 14.7525 12.1095 14.859L10.875 16.0943L9.6405 14.8598C9.53325 14.7525 9.37275 14.721 9.23175 14.7788C9.0915 14.8358 9 14.973 9 15.1245V18.1245C9 18.3315 9.168 18.4995 9.375 18.4995C9.582 18.4995 9.75 18.3315 9.75 18.1245V16.0298L10.6095 16.8893C10.7557 17.0355 10.9935 17.0355 11.1397 16.8893L12 16.0298V18.1245C12 18.3315 12.168 18.4995 12.375 18.4995C12.582 18.4995 12.75 18.3315 12.75 18.1245V15.1245C12.75 14.973 12.6585 14.8358 12.5182 14.778Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapdeviceImei);
export default __webpack_public_path__ + "static/media/map.deviceImei.f1b64a43a5f66446a9907c26370750c4.svg";
export { ForwardRef as ReactComponent };